import { NavLink } from "react-router-dom";
import { ShieldCheck, Coins, ShieldAlert, UserCog, ScrollText, Kanban, Wallet, History, Wrench, Crown, Landmark, SlidersHorizontal } from "lucide-react";

const items = [
  { to: "/app/admin/verificaciones", label: "Verificaciones", icon: ShieldCheck, testid: "adminnav-verificaciones" },
  { to: "/app/admin/planes", label: "Membresías", icon: Crown, testid: "adminnav-planes" },
  { to: "/app/admin/transferencias", label: "Transferencias", icon: Landmark, testid: "adminnav-transferencias" },
  { to: "/app/admin/configuracion", label: "Consola Comercial", icon: SlidersHorizontal, testid: "adminnav-configuracion" },
  { to: "/app/admin/crm", label: "CRM interno", icon: Kanban, testid: "adminnav-crm" },
  { to: "/app/admin/contabilidad", label: "Contabilidad", icon: Wallet, testid: "adminnav-contabilidad" },
  { to: "/app/admin/auditoria", label: "Auditoría", icon: History, testid: "adminnav-auditoria" },
  { to: "/app/admin/profesionales", label: "Gestión de Profesionales", icon: UserCog, testid: "adminnav-profesionales" },
  { to: "/app/admin/mantenimiento", label: "Mantenimiento Usuarios", icon: Wrench, testid: "adminnav-mantenimiento" },
  { to: "/app/admin/mediaciones", label: "Consola de Mediaciones", icon: ScrollText, testid: "adminnav-mediaciones" },
  { to: "/app/admin/tarifas", label: "Tarifas referenciales", icon: Coins, testid: "adminnav-tarifas" },
  { to: "/app/admin/riesgo", label: "Riesgo · fuga", icon: ShieldAlert, testid: "adminnav-riesgo" },
];

export default function AdminNav() {
  return (
    <nav className="mb-6 flex flex-wrap items-center gap-2 border-b border-white/5 pb-3" data-testid="admin-nav">
      {items.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testid}
          className={({ isActive }) =>
            `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
              isActive
                ? "bg-amber-400/15 border border-amber-400/30 text-amber-200"
                : "text-muted-foreground hover:text-foreground border border-transparent hover:border-white/10"
            }`
          }
        >
          <Icon size={13} /> {label}
        </NavLink>
      ))}
    </nav>
  );
}
